(function () {

	// Cache as much of the static elements as we can.
	var productPath = '/' + location.pathname.split('/')[1],
		sectionId = $('#Section').val(),
		antiForgery = $('input[type="hidden"][name="__RequestVerificationToken"]').val(),
		$filterContainer = $('#product-filter-container'),
		$filterGroups = document.querySelector('#product-filter-groups'),
		$filters = $('input[data-filter-option]'),
		$showFiltersBtn = $('#show-filters-btn'),
		$clearFiltersBtn = $('#clear-filters-btn'),
		$applyFiltersBtn = $('#apply-filters-btn'),
		$productList = $('#product-list'),
		$sortDropdown = $('#Sort'),
		filterMap = {};

	// Loop over the filters and create a "map".
	for (var i = 0; i < $filters.length; i++) {

		// Get the individual jQuery object for this filter.
		var $filter = $($filters[i]),
			group = $filter.data('filter-group'),
			value = $filter.val();

		// Ensure the filter group is assigned to the map.
		filterMap[group] = filterMap[group] || {};

		// Assign the filter element to a property that matches the name of the filter.
		filterMap[group][value] = $filter.parent().first();

	}

	function filter() {

		// Get all the currently selected filters.
		var $selectedFilters = $filters.filter(':checked'),
			filtersToApply = [];

		for (var i = 0; i < $selectedFilters.length; i++) {

			// Get the individual jQuery object for this filter.
			var $selectedFilter = $($selectedFilters[i]);

			// Add the filter group and radio value to the array.
			filtersToApply.push([$selectedFilter.data('filter-group'), $selectedFilter.val()]);

		}

		// Wait for both the filters to be refined and the products to be filtered before updating the UI.
		$.when(refineFilters(filtersToApply), filterProducts(filtersToApply))
			.done(updateProducts)
			.fail(showFilterError);

	}

	function refineFilters(filtersToApply) {

		// Get refined filters.
		return $.ajax({
			url: productPath + '/filter/refine',
			method: 'POST',
			cache: false,
			data: {
				sectionId: sectionId,
				filtersToApply: filtersToApply,
				__RequestVerificationToken: antiForgery
			}
		});

	}

	function filterProducts(filtersToApply) {

		// Get filtered products.
		return $.ajax({
			url: productPath + '/filter',
			method: 'POST',
			cache: false,
			data: {
				sectionId: sectionId,
				filtersToApply: filtersToApply,
				sort: $sortDropdown.val(),
				__RequestVerificationToken: antiForgery
			}
		});

	}

	function updateProducts(filterFiltersResult, filterProductsResult) {

		// Get all the filters that are still applicable to the filtered products.
		var applicableFilters = filterFiltersResult[0];

		// Hide all the filters.
		$filters.parent().hide();

		for (var i = 0; i < applicableFilters.length; i++) {

			// Get the filter at the current index.
			var applicableFilter = applicableFilters[i];

			// Lookup the filter element in the map and force it to show.
			filterMap[applicableFilter.Group][applicableFilter.Value].show();

		}

		// For now we'll just overwrite the products with those sent from the server.
		$productList.html(filterProductsResult[0]);

	}

	function showFilterError(xhr, status, error) {

	}

	function resetFilters() {

		// Clear all the radio buttons so that they can be re-selected.
		$filters.prop('checked', false);

		// Reset sort dropdown.
		$sortDropdown.val($sortDropdown.find('option').first().val());

	}

	function clearFilters() {

		// Reset all the filter inputs.
		resetFilters();

		// Filter the products which should essentially reset the display.
		filter();
	}

	function showFilters() {

		// Show the filters.
		$filterContainer.removeClass('d-none');

		// Prevent the body from scrolling.
		bodyScrollLock.disableBodyScroll($filterGroups);

	}

	function hideFilters() {

		// If the filters are already has the 'd-none' class, don't do anything.
		if ($filterContainer.hasClass('d-none')) {
			return;
		}

		// Hide the filters.
		$filterContainer.addClass('d-none');

		// Prevent the body from scrolling.
		bodyScrollLock.enableBodyScroll($filterGroups);

	}

	// Bind filtering action to filter radios.
	$filters.on('change', filter);

	// Bind filtering action to sort dropdown.
	$sortDropdown.on('change', filter);

	// Bind 'show filters' button.
	$showFiltersBtn.on('click', showFilters);

	// Bind 'apply filters' button.
	$applyFiltersBtn.on('click', hideFilters);

	// Bind 'clear filters' button.
	$clearFiltersBtn.on('click', function () {
		clearFilters();
		hideFilters();
	});

	// Bind filter reset when the user uses the browser's back button to get to the product category page.
	$(window).on("pageshow", resetFilters);

})();